import * as React from 'react';
export const IcMergeOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.71 7.7L11 5.41v3.35l2.01-2.01V5.41l.67.67 1.42-1.42-2.37-2.37a.996.996 0 00-1.41 0l-4.01 4A.996.996 0 108.72 7.7h-.01zM21.71 3.7a.996.996 0 000-1.41.99.99 0 00-1.39-.02L2.53 20.06s-.02.01-.03.02l-.21.21a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.36-.36c.14.38.5.66.93.66h1c2.55 0 4.78-1.37 6-3.41A6.986 6.986 0 0018 22h1c.55 0 1-.45 1-1s-.45-1-1-1h-.99c-2.76 0-5-2.24-5-5v-2.61l8.7-8.69zM11 15c0 2.76-2.24 5-5 5h-.6l5.6-5.6v.6z'
      fill='currentColor'
    />
  </svg>
);
